<div class="w-full flex flex-col gap-6 items-center mt-4">
    <img [src]="cdnUrl + '/images/empty-view.png'" height="140" width="170" alt="واحد اقامتی پیدا نشد">

    <p class="text-black-400 text-sm text-center" *ngIf="!hasActiveFilter && serviceStatus == 2">
        هتل در حال حاضر امکان سرویس دهی ندارد
    </p>

    <p class="text-black-400 text-sm text-center" *ngIf="hasActiveFilter">
        متاسفانه هیچ اتاقی متناسب با فیلترهای انتخابی شما پیدا نشد.
    </p>

    <p class="text-black-400 text-sm text-center" *ngIf="!hasActiveFilter && serviceStatus == 1">
        هتل در حال حاضر تعطیل است.
    </p>

    <div class="flex flex-col w-full gap-2 items-center">
        <button
            *ngIf="hasActiveFilter"
            (click)="emitResetFilters()"
            matRipple
            matRippleColor="primary"
            [matRippleColor]="'primary'"
            class="w-60 primary-border rounded-lg py-2 text-blue text-base">حذف فیلتر ها</button>
        <button
            *ngIf="!hasActiveFilter"
            matRipple
            matRippleColor="primary"
            [matRippleColor]="'primary'"
            (click)="naviGateUrl(similarHotelsLink)"
            class="w-60 primary-border cursor-pointer text-base text-white bg-blue-500 rounded-lg py-2 hover:!text-blue hover:!bg-transparent">مشاهده هتل های مشابه</button>
    </div>
</div>
